import { useRef, useState } from "react";

const acceptedTypes = [
  "application/pdf",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/json",
];

export default function TariffDropzone({ file, isAnalyzing, onFileSelected }) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFiles = (files) => {
    const selectedFile = files?.[0];

    if (!selectedFile) {
      return;
    }

    onFileSelected(selectedFile);
  };

  return (
    <section className="card tariff-import-card">
      <div className="section-head">
        <div>
          <h2>1. Datei hochladen</h2>
          <p className="section-text">PDF, CSV, XLSX oder JSON per Klick oder Drag & Drop uebernehmen.</p>
        </div>
      </div>

      <button
        type="button"
        className={`tariff-dropzone ${dragActive ? "tariff-dropzone-active" : ""}`}
        onClick={() => inputRef.current?.click()}
        onDragEnter={(event) => {
          event.preventDefault();
          setDragActive(true);
        }}
        onDragOver={(event) => event.preventDefault()}
        onDragLeave={() => setDragActive(false)}
        onDrop={(event) => {
          event.preventDefault();
          setDragActive(false);
          handleFiles(event.dataTransfer.files);
        }}
      >
        <strong>{file ? file.name : "Datei hier ablegen"}</strong>
        <span>{isAnalyzing ? "Analyse laeuft..." : "PDF, CSV, XLSX, JSON"}</span>
      </button>

      <input
        ref={inputRef}
        type="file"
        className="visually-hidden"
        accept={acceptedTypes.join(",")}
        onChange={(event) => handleFiles(event.target.files)}
      />
    </section>
  );
}
